import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseEntityResource } from '../../core/abstractions/base-entity.resource';
import { ApiResponseModel } from '../../models/core/api-response.model';
import { ResourceConfig } from '../../models/core/resource.config';
import { ReportScheduleDialogParameterFieldModel } from '../../models/report-schedule-dialog-parameter-field.model';
import { ReportModel } from '../../models/report.model';

@Injectable({
    providedIn: 'root'
})
export class ReportsResource extends BaseEntityResource<ReportModel> {
    constructor() {
        super(new ResourceConfig({ baseController: 'reports' }));
    }

    /**
     * Returns all available reports.
     */
    getAll(): Observable<ApiResponseModel<ReportModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<ReportModel[]>>(this.getUrl(''), undefined, undefined, undefined, true);
    }

    /**
     * Returns all parameter fields for a report.
     */
    getParameterFieldsById(id: string): Observable<ApiResponseModel<ReportScheduleDialogParameterFieldModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<ReportScheduleDialogParameterFieldModel[]>>(
            this.getUrl(`${id}/parameter-fields`)
        );
    }
}
